"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeodesicTents = void 0;
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var PlaceMoonColonyTile_1 = require("../../moon/PlaceMoonColonyTile");
var CardRenderer_1 = require("../render/CardRenderer");
var Units_1 = require("../../Units");
var MoonCard_1 = require("./MoonCard");
var TileType_1 = require("../../TileType");
var CardRenderItem_1 = require("../render/CardRenderItem");
var GeodesicTents = (function (_super) {
    __extends(GeodesicTents, _super);
    function GeodesicTents() {
        return _super.call(this, {
            name: CardName_1.CardName.GEODESIC_TENTS,
            cardType: CardType_1.CardType.AUTOMATED,
            tags: [Tags_1.Tags.PLANT, Tags_1.Tags.CITY, Tags_1.Tags.MOON],
            cost: 13,
            productionBox: Units_1.Units.of({ energy: -1, plants: 1 }),
            metadata: {
                description: 'Decrease your energy production 1 step and increase your plant production 1 step. ' +
                    'Spend 1 titanium. Place a colony tile on the Moon and raise the Colony Rate 1 step.',
                cardNumber: 'M06',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) {
                        pb.minus().energy(1).nbsp.plants(1);
                    }).br;
                    b.minus().titanium(1).br;
                    b.moonColony().secondaryTag(CardRenderItem_1.AltSecondaryTag.MOON_COLONY_RATE);
                }),
            },
        }, {
            reserveUnits: Units_1.Units.of({ titanium: 1 }),
            tilesBuilt: [TileType_1.TileType.MOON_COLONY],
        }) || this;
    }
    GeodesicTents.prototype.play = function (player) {
        _super.prototype.play.call(this, player);
        player.game.defer(new PlaceMoonColonyTile_1.PlaceMoonColonyTile(player));
        return undefined;
    };
    return GeodesicTents;
}(MoonCard_1.MoonCard));
exports.GeodesicTents = GeodesicTents;
//# sourceMappingURL=GeodesicTents.js.map